import script from "./TestResultModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TestResultModal.vue?vue&type=script&setup=true&lang=js"

import "./TestResultModal.vue?vue&type=style&index=0&id=28e58839&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28e58839"]])

export default __exports__